import { useMemo, useState } from 'react';
import { ColDef } from 'ag-grid-community';
import {
  ICaptableDataModel,
  ICaptableInvestmentDataModel,
} from '../../../../data-models/captable2.data-model';
import { AgTable } from '../../../../components/AgTable/AgTable';
import { InvestmentTypeToName, ShareClass } from '../../../../view-models/captable.view-model';
import { ChipSelector } from '../../../../components/ChipSelector';
import { FadeInGridWrapper } from '../../../../components/grid-renderers/FadeInGridWrapper';
import { CapTableInvestmentType } from '../../../../schemas/CaptableInvestment.schema';
import { getInvestmentRowData } from './CTInvestmentRowData';
import { DefaultColDefs, useInvestmentColDefs } from './CTInvestmentDetailsColDefs';

interface ICTInvestmentDetailsProps {
  data: ICaptableDataModel;
}
export function CTInvestmentDetails({ data }: ICTInvestmentDetailsProps) {
  const [selectedType, setSelectedType] = useState<CapTableInvestmentType>('share-class');
  const options = useMemo(() => {
    return Object.entries(InvestmentTypeToName).map(([key, value]) => ({
      displayName: value,
      value: key as CapTableInvestmentType,
    }));
  }, []);

  const rowData = getInvestmentRowData(data, {
    investmentTypeFilter: selectedType,
  });
  const colDefs = useInvestmentColDefs(selectedType) as ColDef<ICaptableInvestmentDataModel | ShareClass>[];

  return (
    <>
      <ChipSelector
        value={selectedType}
        options={options}
        onChange={(newValue) => setSelectedType(newValue)}
      />
      <FadeInGridWrapper key={selectedType}>
        <div style={{ height: 'calc(100dvh - 35rem)', padding: '0' }}>
          <AgTable
            rowData={rowData}
            columnDefs={colDefs}
            rowGroupPanelShow='never'
            grandTotalRow='bottom'
            defaultColDef={DefaultColDefs}
          />
        </div>
      </FadeInGridWrapper>
    </>
  );
}
